import React from "react";
import SVG from "react-inlinesvg";
import Modal from "react-modal";
import { t } from "ttag";

import iconIconEmail from "../../img/retail-locator/icon-email.svg";
import iconXClose from "../../svg/x-close.svg";
import { LocatorSendSingleStoreForm } from "./LocatorSendSingleStore_Form";

export const LocatorSendSingleStoreModal = (props: {
    onSubmit: (recipient: string) => Promise<void>;
}): React.ReactNode => {
    const [isOpen, setIsOpen] = React.useState(false);
    const [isSubmitting, setIsSubmitting] = React.useState(false);

    const onOpen = () => {
        setIsOpen(true);
    };

    const onClose = () => {
        setIsOpen(false);
    };

    const onSubmit = async (recipient: string) => {
        setIsSubmitting(true);
        try {
            await props.onSubmit(recipient);
        } catch (e) {
            setIsSubmitting(false);
            setIsOpen(true);
        } finally {
            setIsSubmitting(false);
            setIsOpen(false);
        }
    };

    return (
        <>
            <button
                onClick={onOpen}
                className="info__actions-icon info__actions-icon--button"
            >
                <img alt={t`Email Icon`} src={iconIconEmail} />
            </button>
            <span className="info__actions-label">{t`Email`}</span>
            <Modal
                aria={{
                    modal: true,
                }}
                style={{
                    content: {
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        maxHeight: "95%",
                        maxWidth: "542px",
                        width: "96%",
                        overflow: "auto",
                        padding: "40px",
                    },
                }}
                contentLabel={t`Email Me Details About This Store.`}
                portalClassName="locator"
                className={`locations modal`}
                isOpen={isOpen}
                onRequestClose={onClose}
                role="dialog"
            >
                <button
                    aria-label={t`Close`}
                    className="modal-close button--ghost"
                    onClick={onClose}
                >
                    <SVG
                        aria-hidden="true"
                        className="modal-close__icon"
                        src={iconXClose}
                        title={t`Close Icon`}
                    />
                </button>
                <LocatorSendSingleStoreForm
                    isSubmitting={isSubmitting}
                    onCancel={onClose}
                    onSubmit={onSubmit}
                />
            </Modal>
        </>
    );
};
